/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import { InitiativeData } from '../types/initiative';

export type InitiativeState = InitiativeStateEmpty | InitiativeStateLoaded;

interface InitiativeStateEmpty {
  loaded: false;
  data: undefined;
  id: null | string;
  errored: boolean;
  errorMessage: string;
  lastUpdated?: number;
}

interface InitiativeStateLoaded {
  loaded: true;
  data: InitiativeData;
  id: string;
  errored: boolean;
  errorMessage: string;
  lastUpdated?: number;
}

const initiative = (

  state: (InitiativeStateEmpty | InitiativeStateLoaded) = {
    data: undefined,
    id: null,
    loaded: false,
    errored: false,
    errorMessage: ''
  },

  action: AnyAction

): (InitiativeStateEmpty | InitiativeStateLoaded) => {

  switch (action.type) {

    case actionTypes.LOADING_INITIATIVE:
      return { ...state, id: action.id, data: undefined, loaded: false, errored: false, lastUpdated: Date.now() }
    case actionTypes.ERROR_INITIATIVE:
      return { ...state, data: undefined, loaded: false, errored: true, errorMessage: action.errorMessage }
    case actionTypes.LOADED_INITIATIVE:
      return { ...state, id: action.id, data: action.data, loaded: true, errored: false, lastUpdated: Date.now() }
    default:
      return state;

  }

}

export default initiative;
